/**
 * Intercepteur global axios — gère les 401 (session expirée) et redirige vers /login.
 * Corrige le bug "Not authenticated" qui apparaissait lorsque le token JWT expirait
 * pendant que l'utilisateur remplissait un formulaire (ex: ajout d'agent terrain).
 */
import axios from 'axios';
import { toast } from 'sonner';
import { tokenService } from './tokenService';

let interceptorInstalled = false;

export const installAuthInterceptor = () => {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || '';
      const isAuthEndpoint = url.includes('/api/auth/login')
        || url.includes('/api/auth/register')
        || url.includes('/api/auth/verify-otp')
        || url.includes('/api/auth/resend-otp')
        || url.includes('/api/auth/forgot-password')
        || url.includes('/api/auth/reset-password')
        || url.includes('/api/auth/activate');

      if ((status === 401 || status === 403) && !isAuthEndpoint) {
        const detail = error?.response?.data?.detail || '';
        // Ne redirige QUE si le message évoque une session/token invalide
        const authRelated = status === 401
          || /token|authenti|session|not authenticated|invalide|expir/i.test(detail);
        if (!authRelated) return Promise.reject(error);
        // On ne redirige qu'une seule fois si l'utilisateur a une session existante.
        const hadToken = !!tokenService.getToken();
        tokenService.clearAll();
        if (hadToken) {
          toast.error('Session expirée. Veuillez vous reconnecter.');
        } else {
          toast.error('Vous devez être connecté pour effectuer cette action.');
        }
        // Redirection différée pour laisser le toast s'afficher
        setTimeout(() => {
          const currentPath = window.location.pathname;
          if (!currentPath.startsWith('/login') && !currentPath.startsWith('/register')) {
            const redirect = encodeURIComponent(currentPath + window.location.search);
            window.location.href = `/login?redirect=${redirect}`;
          }
        }, 800);
      }
      return Promise.reject(error);
    }
  );
};
